/* eslint-disable import/prefer-default-export */

export const phoneRegex =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export const zipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;